import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { oneGraphClient } from '../../constants/environment';
import { STOCK_CAR_SEARCH } from '../../schemas/StockCarSearch';
import { CA_MARKET } from '../../constants';
import { STOCK_CAR } from '../../schemas/StockCar';

const useFetchByVin = (vehicleId: string | null, market: string, vehicleType: string | null) => {
  const vehicleMarket = market === CA_MARKET ? 'ca' : 'us';
  const correctType = vehicleType === 'new' ? 'NEW' : 'USED';
  const isUsMarket = market !== CA_MARKET;

  const statImport = isUsMarket ? 'AGC_USA_JDP' : 'AGC_CAN_JDP';

  const isVin = vehicleId?.length === 17 && !vehicleId.includes('=');

  const shouldLoadByVin = !!vehicleId && isVin;
  const shouldLoadById = !!vehicleId && !isVin;

  const finilizedCriteria = useMemo(
    () => [
      {
        id: 'stat-import',
        items: [statImport],
      },
      {
        id: 't_vin',
        items: [vehicleId],
      },
    ],
    [statImport, vehicleId],
  );

  const stockCarSearcVariables = useMemo(() => {
    return {
      stockIdentifier: {
        marketIdentifier: {
          brand: 'A',
          country: vehicleMarket,
          language: 'en',
        },
        stockCarsType: correctType,
      },
      searchParameter: {
        criteria: finilizedCriteria,
        paging: { limit: 2, offset: 0 },
      },
      groupIds: ['renderImagesPNG', 'dealerImages'],
      imageIds: ['sc5c01', '1'],
    };
  }, [correctType, finilizedCriteria, vehicleMarket]);

  const stockCarVarialbes = useMemo(() => {
    return {
      stockCarIdentifier: {
        id: vehicleId,
        stockIdentifier: {
          marketIdentifier: {
            brand: 'A',
            country: vehicleMarket,
            language: 'en',
          },
          stockCarsType: correctType,
        },
      },
      groupIds: ['renderImagesPNG', 'dealerImages'],
      imageIds: ['sc5c01', '1'],
    };
  }, [correctType, vehicleId, vehicleMarket]);

  const {
    data: idData,
    loading: idLoading,
    error: idError,
  } = useQuery(STOCK_CAR, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip: !shouldLoadById,
    client: oneGraphClient,
    variables: stockCarVarialbes,
  });

  const {
    data: vinData,
    loading: vinLoading,
    error: vinError,
  } = useQuery(STOCK_CAR_SEARCH, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip: !shouldLoadByVin,
    client: oneGraphClient,
    variables: stockCarSearcVariables,
  });

  const vehicleVinData = vinData?.stockCarSearch?.results?.cars[0]?.stockCar;
  const vehicleIdData = idData?.stockCar;

  const vehicleData = vehicleVinData ?? vehicleIdData;
  const loading = idLoading || vinLoading;

  return { vehicleData, loading };
};

export default useFetchByVin;
